import { post, get } from '.';

export const sendRequestAccess = () => post(`/dmcRequestAccess`);
export const getRequestAccess = () => get(`/dmcRequestAccess/`);
